export default "__VITE_ASSET__D_m2QyZt__"